import BaseAuthClient from './baseAuth';

class ComicClient extends BaseAuthClient {
  constructor() {
    super({
      baseURL: '/api'
    });
  }
}

const comicClient = new ComicClient();

export default comicClient;

// 获取图片信息
export const getpostil = (option: any) => comicClient.get(`v2/postil/getpostil`, option);
export const addpostil = (option: any) => comicClient.post(`v2/postil/addpostil`, option);
